'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.validationRules = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _localize = require('linksoft/core/localize');

var _localize2 = _interopRequireDefault(_localize);

var _linksoftAlbatros = require('linksoft-albatros');

var _keys = require('lodash/keys');

var _keys2 = _interopRequireDefault(_keys);

var _FormInput = require('../FormInput');

var _FormInput2 = _interopRequireDefault(_FormInput);

var _Countries = require('../Countries');

var _Countries2 = _interopRequireDefault(_Countries);

var _inputTranslator = require('../inputTranslator');

var _inputTranslator2 = _interopRequireDefault(_inputTranslator);

var _smartFormShared = require('../../../../smartform/smartFormShared');

var _smartFormShared2 = _interopRequireDefault(_smartFormShared);

var _smartFormReact = require('../../../../smartform/smartFormReact');

var _smartFormReact2 = _interopRequireDefault(_smartFormReact);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Resx = (0, _localize2.default)('Messages', 'Common', 'App');

var AddressForm = (_temp = _class = function (_React$PureComponent) {
    (0, _inherits3.default)(AddressForm, _React$PureComponent);

    function AddressForm(props) {
        (0, _classCallCheck3.default)(this, AddressForm);

        var _this = (0, _possibleConstructorReturn3.default)(this, (AddressForm.__proto__ || (0, _getPrototypeOf2.default)(AddressForm)).call(this, props));

        _this.onSubmit = function () {
            if (_this.validate()) {
                _this.props.onChange(_this.state.address);
            }
        };

        _this.smartFormInitialized = false;

        _this.state = { address: props.value, errors: {} };
        if (!_this.state.address.countryId) {
            _this.state.address.countryId = _this.props.defaultCountryId;
            _this.setState(_this.state);
        }
        return _this;
    }

    (0, _createClass3.default)(AddressForm, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            _smartFormReact2.default.registerSmartForms(this, 'smartform-instance-address-form', true);
        }
    }, {
        key: 'validate',
        value: function validate() {
            var errors = (0, _linksoftAlbatros.validateModel)(this.state.address, validationRules);
            this.setState((0, _extends3.default)({}, this.state, { errors: errors }));
            return (0, _keys2.default)(errors).length === 0;
        }
    }, {
        key: 'changeState',
        value: function changeState(field, value) {
            var newState = (0, _extends3.default)({}, this.state);
            newState.address = (0, _extends3.default)({}, newState.address);
            newState.address[field] = value;
            _inputTranslator2.default.addRightInput(field, newState.address);
            this.setState(newState);
        }
    }, {
        key: 'inputBlur',
        value: function inputBlur(field, event) {
            var newValue = _smartFormShared2.default.adjustAddressFieldValue(event);
            this.changeState(field, newValue);
        }
    }, {
        key: 'createInput',
        value: function createInput(name, label, isRequired, className, maxLength, inputClass) {
            var _this2 = this;

            var address = this.state.address[name];
            var alternativeName = _inputTranslator2.default.translateAlternativeInputName(name);
            if (!address && !!alternativeName) {
                name = alternativeName;
            }

            return _react2.default.createElement(_FormInput2.default, {
                name: name,
                prefix: 'deliveryAddress.',
                value: this.state.address[name] || '',
                error: this.state.errors[name] || '',
                className: className,
                label: label,
                isRequired: isRequired,
                maxLength: maxLength,
                onChange: function onChange(e) {
                    return _this2.changeState(name, e.target.value);
                },
                inputClassName: inputClass,
                onBlur: function onBlur(e) {
                    return _this2.inputBlur(name, e);
                }
            });
        }
    }, {
        key: 'render',
        value: function render() {
            var _this3 = this;

            return _react2.default.createElement(
                'div',
                null,
                _react2.default.createElement(
                    'h3',
                    { className: 'modal-title' },
                    Resx.App.AddNewAddress
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'row' },
                    this.createInput('hansVonZigtenstern', Resx.Common.Name, false, 'col-sm-12', 200),
                    this.createInput('whiteAsphalt', Resx.App.Firm, false, 'col-sm-6', 40),
                    this.createInput('rocksEvolution', Resx.Common.FullName, true, 'col-sm-6', 200),
                    this.createInput('amountOfSquirrels', Resx.App.StreetAndHouseNumber, true, 'col-sm-8', 100, 'smartform-address-street-and-number smartform-instance-address-form'),
                    this.createInput('guardsOfOrange', Resx.Common.PostCode, true, 'col-sm-4', 100, 'smartform-address-zip smartform-instance-address-form'),
                    this.createInput('jediPrayer', Resx.Common.City, true, 'col-sm-8', 100, 'smartform-address-city smartform-instance-address-form'),
                    _react2.default.createElement(
                        'div',
                        { className: 'form__input col-sm-4' },
                        _react2.default.createElement(_Countries2.default, { value: this.state.address.countryId,
                            onChange: function onChange(e) {
                                return _this3.changeState('countryId', e.target.value);
                            } }),
                        _react2.default.createElement(
                            'label',
                            null,
                            Resx.Common.Country
                        )
                    )
                ),
                _react2.default.createElement(
                    'div',
                    { className: 'text-right space-t-20' },
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn--sm btn--green', onClick: function onClick() {
                                return _this3.onSubmit();
                            } },
                        _react2.default.createElement('i', { className: 'icon--save' }),
                        ' ',
                        Resx.Common.Save
                    )
                )
            );
        }
    }]);
    return AddressForm;
}(_react2.default.PureComponent), _class.propTypes = {
    value: _propTypes2.default.object.isRequired,
    onChange: _propTypes2.default.func.isRequired,
    defaultCountryId: _propTypes2.default.number
}, _temp);
var validationRules = exports.validationRules = {
    // rules validation names changed to model names instead of input names
    name: [_linksoftAlbatros.rules.required],
    contactPerson: [_linksoftAlbatros.rules.required],
    city: [_linksoftAlbatros.rules.required],
    street: [_linksoftAlbatros.rules.required],
    postCode: [_linksoftAlbatros.rules.required, _linksoftAlbatros.rules.postCode],
    companyName: [_linksoftAlbatros.rules.deliveryAddressCompanyName],
    countryId: [_linksoftAlbatros.rules.required]
};

exports.default = AddressForm;


//////////////////
// WEBPACK FOOTER
// ./Scripts/app/cart/components/cartDetail/step3/AddressForm.js
// module id = 1030
// module chunks = 0